const kalenderCjjbf = [
     {
        id: 1,
        title: 'XV COMBAT JU-JUTSU WORLD CHAMPIONSHIP',
        dateEvent: '3 December - 7 December 2026',
        location: 'Prague, Czech Republic',
        hyperlink: 'https://cjjif.org/events/wcprague2026.pdf'
    },
    {
        id: 2,
        title: 'CJJIF COMBAT JU-JUTSU WORLD CHAMPIONSHIP',
        dateEvent: '27 November - 30 November 2025',
        location: 'Madrid, Spain',
        hyperlink: 'https://fitofan.com/o708434618?p=results'
    },
    {
        id: 3,
        title: 'WORLD CHAMPIONSHIP COMBAT JU-JUTSU',
        dateEvent: '28 November - 1 December 2024',
        location: 'Mikolow, Poland',
        hyperlink: 'https://fitofan.com/o708434618?p=results'
    },
];

export default kalenderCjjbf;